import { Link } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  showHome?: boolean
  className?: string
}

export function Breadcrumb({ items, showHome = true, className = '' }: BreadcrumbProps) {
  const allItems: BreadcrumbItem[] = showHome
    ? [{ label: 'Home', href: '/' }, ...items]
    : items

  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex items-center gap-2 text-sm flex-wrap">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1
          const isHome = index === 0 && showHome

          return (
            <li key={index} className="flex items-center gap-2">
              {index > 0 && (
                <ChevronRight className="w-4 h-4 text-slate-300 flex-shrink-0" />
              )}

              {isLast ? (
                <span className="text-slate-900 font-medium truncate max-w-[200px]">
                  {item.label}
                </span>
              ) : item.href ? (
                <Link
                  to={item.href}
                  className="text-slate-500 hover:text-slate-700 flex items-center gap-1"
                >
                  {isHome && <Home className="w-4 h-4" />}
                  <span className={isHome ? 'sr-only sm:not-sr-only' : ''}>
                    {item.label}
                  </span>
                </Link>
              ) : (
                <span className="text-slate-500">
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

// Pre-built breadcrumb sections for common pages
export function BrowseBreadcrumb({ category, group }: { category?: string; group?: string }) {
  const items: BreadcrumbItem[] = [{ label: 'Browse', href: '/browse' }]

  if (group) {
    items.push({ label: group })
  }

  if (category) {
    items.push({ label: category })
  }

  return <Breadcrumb items={items} />
}

export function ProfileBreadcrumb({ section }: { section: string }) {
  return (
    <Breadcrumb
      items={[
        { label: 'Profile', href: '/profile' },
        { label: section },
      ]}
    />
  )
}

export function CreateListingBreadcrumb({ step }: { step?: string }) {
  const items: BreadcrumbItem[] = [{ label: 'Create Listing', href: '/create' }]

  if (step) {
    items.push({ label: step })
  }

  return <Breadcrumb items={items} />
}
